<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small class="font-size:15px; font-weight: bold">Manage attendances</small>
      </legend>
      <div></div>
      <div>
        <div class="attendancesLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>
          loading attendances...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemAttendances"
          :fixed-header="true"
          :pagination-options="{
              enabled: true,
              mode: 'records',
              perPage: 6,
              position: 'bottom',
              perPageDropdown: [3, 7, 9],
              dropdownAllowAll: false,
              setCurrentPage: 1,
              nextLabel: 'next',
              prevLabel: 'prev',
              rowsPerPageLabel: 'rows per page',
              ofLabel: 'of',
              pageLabel: 'page', //for 'pages' mode
              allLabel: 'all'
            }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Action'">
             

              <span v-if="props.row.time_in">
                <button
                  v-if="!props.row.time_out"
                  class="btn btn-raised btn-raised-info btn-sm m-1 attendanceId updatingAttendance"
                  @click.once="checkOut(props.row.id)"
                >
                <i class="nav-icon i-Pen-2 font-weight-bold"></i> Check out
                </button>
                <button type="button" class="btn btn-info btn-flat updatingAttendanceLoader">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please
                  wait...
                </button>
              </span>
            </span>
            <span v-else>{{props.formattedRow[props.column.field]}}</span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Employee name",
          field: "employee_no",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter id number"
          }
        },
        {
          label: "Employee name",
          field: "employee_name"
        },
        {
          label: "Time in",
          field: "time_in"
        },
        {
          label: "Time_out",
          field: "time_out"
        },
        {
          label: "Total hours",
          field: "total_hours"
        },
        {
          label: "Action",
          field: "Action",
          // width: "120px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadAttendances();
  },
  computed: {
    ...mapGetters(["systemAttendances"])
  },
  methods: {
    ...mapActions(["loadAttendances",  "checkOut"])
  }
};
</script>
<style scoped>
.creatingAttendanceLoader {
  display: none;
}
.updatingAttendanceLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/attendances/manageattendances.vue